import router from "next/router";

export const getLocale = () => {
  return router?.locale?.includes("fr") ? "fr" : "en";
};
